export const ABOUTCONTENT_INTROPANEL_ID = "aboutcontent_intropanel"
